import { provideHttpClient, withFetch } from "@angular/common/http";
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  provideRouter,
  withInMemoryScrolling,
  withViewTransitions,
} from "@angular/router";
import { providePrimeNG } from "primeng/config";
import { appRoutes } from "./app.routes";
import { DeviceDetectorService } from "ngx-device-detector";
import { DatePipe } from "@angular/common";
import { NGX_LOCAL_STORAGE_CONFIG } from "ngx-localstorage";

import { MessageService } from "primeng/api";
import { provideAnimations } from "@angular/platform-browser/animations";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  provideClientHydration,
  withEventReplay,
} from "@angular/platform-browser";
import MyPreset from "./mypreset";
import { AuthTokenService } from "./services/auth-token.service";
import { StorageService } from "./services/storage.service";
import { LocationService } from "./services/location.service";
import { DataService } from "./services/data.service";
import { environment } from "@environment";

// Assuming ngxLocalstorageConfiguration is properly defined elsewhere in your code
const ngxLocalstorageConfiguration = NGX_LOCAL_STORAGE_CONFIG as unknown as {
  prefix: string;
  delimiter: string;
};

function initAppFactory(
  authTokenService: AuthTokenService,
  storage: StorageService,
) {
  return () => {
    const urlParams = new URLSearchParams("");
    const token = urlParams.get("token");

    if (token) {
      authTokenService.setToken(token);
      storage.set(environment.tokenKey, token);
    }

    return Promise.resolve();
  };
}

export function tokenGetter(): string {
  // Try both possible token keys
  const tokenKey = `${ngxLocalstorageConfiguration.prefix}${ngxLocalstorageConfiguration.delimiter}${environment.tokenKey}`;
  const token =
    localStorage.getItem(tokenKey) ||
    localStorage.getItem(environment.tokenKey);

  if (!token) {
    console.debug("No token found in localStorage");
    return "";
  }

  try {
    // Remove quotes and any whitespace
    const cleanToken = token.replace(/['"]+/g, "").trim();
    return cleanToken;
  } catch (error) {
    console.error("Error processing token:", error);
    return "";
  }
}

export let appConfig: ApplicationConfig;
appConfig = {
  providers: [
    // Other providers
    importProvidersFrom(BrowserAnimationsModule, NgxIntlTelInputModule),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
      withViewTransitions(),
    ),
    importProvidersFrom(),
    provideHttpClient(withFetch()),
    {
      provide: APP_INITIALIZER,
      useFactory: initAppFactory,
      deps: [
        AuthTokenService,
        StorageService,
        LocationService,
        DataService,
        MessageService,
      ],
      multi: true,
    },
    MessageService,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: ".app-dark",
        },
      },
    }),
    DeviceDetectorService,
    DatePipe,
    {
      provide: NGX_LOCAL_STORAGE_CONFIG,
      useValue: NGX_LOCAL_STORAGE_CONFIG,
    },
    provideAnimations(), // Required for ngx-bootstrap
    provideClientHydration(withEventReplay()),
    provideZoneChangeDetection({ eventCoalescing: true }),
  ],
};
